// extracted by mini-css-extract-plugin
export default {"button":"AddPhotoButton_button__19qWl","inputDisabled":"AddPhotoButton_inputDisabled__8fQM7"};